import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCardTitle,{staticClass:"pt-1 pb-1 headline grey lighten-2",attrs:{"color":"primary","primary-title":""}},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.dialogName))]),_c(VSpacer),_c(VBtn,{attrs:{"fab":"","rounded":"","small":"","text":""},on:{"click":function($event){$event.stopPropagation();return _vm.close()}}},[_vm._v(" X ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }